// @ts-ignore
import { getSavedBoolean, saveBoolean } from "webkit/utils/localStorage"

const DIALOG_CLOSED_KEY = "BANNER_DIALOG_CLOSED"
export const saveDialogClose = () => saveBoolean(DIALOG_CLOSED_KEY, true)

export const checkWasBannerClosedOnce = () => getSavedBoolean(DIALOG_CLOSED_KEY)
